import React, {useState} from 'react';
import Collapsible from './collapsible';
import List from './case/list';
import '../style.css';
import { AdminStatus } from './statuses';

function Nurse({cases, setCases, token, inverted}){

    const [counters, setCounters] = useState(new Array(3).fill(0));

    return (
        <div className='Layout'>
            <Collapsible title={`New Cases`}>
                <div className='case headings'>
                    <h6 className='col head'>Reference</h6>
                    <h6 className='col head'>Address</h6>
                    <h6 className='col head'>Phone Number</h6>
                    <h6 className='col head'>Name</h6>
                    <span/>
                    <span/>
                    <span/>
                </div>
                <List nurse={true} index={0} setCases={setCases} status={AdminStatus.assigned} cases={cases} inverted={inverted} token={token}/>
            </Collapsible>
            <Collapsible title={`Appointments`}>
                <div className='case headings'>
                    <h6 className='col head'>Reference</h6>
                    <h6 className='col head'>Address</h6>
                    <h6 className='col head'>Services</h6>
                    <h6 className='col head'>Appointment Date</h6>
                    <span/>
                    <span/>
                    <span/>
                </div>
                <List nurse={true} index={1} setCases={setCases} status={AdminStatus.aptmade} cases={cases} inverted={inverted} token={token}/>
                <h4 style={{marginLeft:"20px"}}>Rescheduled</h4>
                <List nurse={true} index={1} setCases={setCases} status={AdminStatus.aptresc} cases={cases} inverted={inverted} token={token}/>
            </Collapsible>
            <Collapsible title={`Awaiting Test Results`}>
                <div className='case headings'>
                    <h6 className='col head'>Reference</h6>
                    <h6 className='col head'>First Name</h6>
                    <h6 className='col head'>Last Name</h6>
                    <h6 className='col head'>Services</h6>
                    <span/>
                    <span/>
                    <span/>
                </div>
                <List nurse={true} index={2} setCases={setCases} status={AdminStatus.aptcomp} cases={cases} inverted={inverted} token={token}/>
            </Collapsible>
            
        </div>
    )
}

export default Nurse;